import React from 'react';
import {
  IoSchoolOutline,
  IoBriefcaseOutline,
  IoCalendarOutline,
} from 'react-icons/io5';
import * as mystyles from '../styles/Journey.module.scss';
import '../styles/global.scss';

export default function Journey(props) {
  return (
    <div className="pb-16 w-11/12 mx-auto">
      <div className=" mb-12 md:mb-20">
        <div
          className={` text-center uppercase font-bold text-sm tracking-wider text-about-secondary relative heading`}
        >
                    My Awesome Journey
        </div>
      </div>
      <div className=" grid grid-cols-1 w-full mx-auto sm:gap-4 md:grid-cols-2 md:w-full lg:w-4/5">
        <div className="ml-4 md:ml-12">
          <div className=" text-2xl font-bold flex gap-4 items-center text-gray-600">
            <IoBriefcaseOutline />
                        Experience
          </div>
          {props.data.experience.map((item, idx) => {
            return (
              <div
                key={idx}
                className={`my-8 relative flex  ${mystyles.card}`}
              >
                <div className={`${mystyles.sideIcon}`}>
                  <div
                    className={`w-5 h-5 mt-1 rounded-full bg-about-primary border-about-primary border-solid border-2 shadow-circle relative`}
                  ></div>
                </div>
                <div className="pl-12">
                  <h3 className=" text-lg font-bold text-gray-700">
                    {item.company}
                  </h3>
                  <h4 className=" text-base text-gray-600 mb-1">
                    {item.role}
                  </h4>
                  <h4 className=" text-base text-gray-600 mb-3">
                    {item.location}
                  </h4>
                  <div className=" flex gap-2 items-center text-about-primary text-sm">
                    <IoCalendarOutline />
                    <div>
                      {item.start}-{item.end}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="ml-4 md:ml-12">
          <div className=" text-2xl font-bold flex gap-4 items-center text-gray-600">
            <IoSchoolOutline />
                        Education
          </div>
          {props.data.education.map((item, idx) => {
            return (
              <div
                key={idx}
                className={`my-8 relative flex  ${mystyles.card}`}
              >
                <div className={`${mystyles.sideIcon}`}>
                  <div
                    className={`w-5 h-5 mt-1 rounded-full bg-about-primary border-about-primary border-solid border-2 shadow-circle relative`}
                  ></div>
                </div>
                <div className="pl-12">
                  <h3 className=" text-lg font-bold text-gray-700">
                    {item.institute}
                  </h3>
                  <h4 className=" text-base text-gray-600 mb-1">
                    {item.course}
                  </h4>
                  <h4 className=" text-base text-gray-600 mb-3">
                    {item.location}
                  </h4>
                  <div className=" flex gap-2 items-center text-about-primary text-sm">
                    <IoCalendarOutline />
                    <div>
                      {item.start}-{item.end}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
